// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2026project/q2/2026autumn_hotpot/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

// 活动规则
const getRule = () => {
  return http.get(`${urlPrefix}rules`);
};

// 抽奖（每人每天一次）
const luckDraw = (data: any) => {
  return http.post(`${urlPrefix}luck-draw`, qs.stringify(data));
};

// 用户中奖列表
const getPrizeList = (page: number = 1, unionid: string | null = null) => {
  const qsData = qs.stringify({ page, unionid });
  return http.get(`${urlPrefix}prize-list&${qsData}`);
};

// 中实物填写收货地址
const fillAddress = (data: any) => {
  return http.post(`${urlPrefix}fill-address`, qs.stringify(data));
};

// 中奖记录详情（含已填写的收货信息）
const getPrizeDetail = (
  id: number | string,
  unionid: string | null = null,
) => {
  const qsData = qs.stringify({ id, unionid });
  return http.get(`${urlPrefix}prize-detail&${qsData}`);
};

// 当天剩余抽奖次数
const getDrawNum = (unionid: string | null = null) => {
  const qsData = qs.stringify({ unionid });
  return http.get(`${urlPrefix}draw-num&${qsData}`);
};

// 奖品配置列表
const getPrizeConfig = () => {
  return http.get(`${urlPrefix}prize-config`);
};

export {
  getBaseInfo,
  getRule,
  luckDraw,
  getPrizeList,
  getPrizeDetail,
  fillAddress,
  getDrawNum,
  getPrizeConfig,
};
